import React from 'react';
import { Link } from 'react-router-dom';

function ImpactJoin() {
  const stats = [
    { label: 'Fellows & Scholars', value: '300+' },
    { label: 'Research Projects', value: '50+' },
    { label: 'Datasets Published', value: '50+' },
    { label: 'Students Reached', value: '10k+' }
  ];

  return (
    <section id="impact-join" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Impact & How to Get Involved</h2>
            <p className="text-lg text-gray-600 mb-6">We are building an ecosystem where research leads to practical change for students. You can contribute by joining the fellowship, collaborating on research, funding scholarships, or adopting our EdTech tools.</p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a href="#fellowship" className="px-6 py-3 bg-[rgb(130,88,18)] text-white rounded-full hover:bg-[rgb(110,68,0)] transition-colors duration-300 text-center focus:outline-none focus:ring-2 focus:ring-[rgb(130,88,18)]">
                Join the Fellowship
              </a>
              <Link to="/donate" className="px-6 py-3 border-2 border-[rgb(130,88,18)] text-[rgb(130,88,18)] rounded-full hover:bg-[rgb(130,88,18)] hover:text-white transition-colors duration-300 text-center focus:outline-none focus:ring-2 focus:ring-[rgb(130,88,18)]">
                Support Our Work
              </Link>
              <Link to="/scholarships" className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-full hover:bg-gray-50 transition-colors duration-300 text-center focus:outline-none focus:ring-2 focus:ring-gray-300">
                Apply for Scholarship
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((item, idx) => (
              <div key={idx} className="text-center bg-gray-50 rounded-xl p-6 border border-gray-100">
                <div className="text-3xl font-bold text-[rgb(130,88,18)] mb-1">{item.value}</div>
                <div className="text-gray-600 text-sm">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ImpactJoin;


